export default __webpack_public_path__ + "static/media/Answer-Button.5db54089.svg";